import { render, staticRenderFns } from "./TrCategory.vue?vue&type=template&id=79cc4dcd&"
import script from "./TrCategory.vue?vue&type=script&lang=js&"
export * from "./TrCategory.vue?vue&type=script&lang=js&"
import style0 from "./TrCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports